import { render, staticRenderFns } from "./wy-interactions-contact-reasons-detail-metrics-chart.vue?vue&type=template&id=d9fc6440&"
import script from "./wy-interactions-contact-reasons-detail-metrics-chart.vue?vue&type=script&lang=js&"
export * from "./wy-interactions-contact-reasons-detail-metrics-chart.vue?vue&type=script&lang=js&"
import style0 from "./wy-interactions-contact-reasons-detail-metrics-chart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports